module.exports = __webpack_public_path__ + "files/227ab13f980c6a9fa1eb1c82c284ab85.png";